import { call, put, takeLatest } from 'redux-saga/effects';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { FETCH_PLAN_CANCELLATION_FEE } from './actionTypes';
import { doneFetchingPlanCancellationFee, errorFetchingPlanCancellationFee } from './actionCreators';
import { logout } from '../auth/actionCreators';
import HeroCommerceApi from 'api-services/HeroCommerceApi';
export function* getPlanCancellationFee(constAccessParams) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroCommerceApi.getPlanCancellationFee, newAccessParams);
    if (isSuccessResponse(result)) {
        yield put(doneFetchingPlanCancellationFee(result.data.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(errorFetchingPlanCancellationFee(result.msg));
    }
}
export function* watchFetchPlanCancellationFeeCalls(constAccessParams) {
    yield takeLatest(FETCH_PLAN_CANCELLATION_FEE, getPlanCancellationFee, constAccessParams);
}
//# sourceMappingURL=saga.js.map